"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Ellipsis = _interopRequireDefault(require("../common/Ellipsis"));
var _TooltipCommon = require("../common/PropTypes/TooltipCommon");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _generateDataAttr = require("../utils/generateDataAttr");
var _TextButtonSt = require("./TextButton.st.css");
var _ButtonCore = _interopRequireDefault(require("../Button/ButtonCore"));
var _excluded = ["skin", "underline", "weight", "size", "children", "className", "dataHook", "fluid", "ellipsis", "showTooltip", "tooltipProps", "ariaLabel", "ariaLabelledBy", "ariaHaspopup", "ariaExpanded"];
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/TextButton/TextButton.js";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class TextButton extends _react.PureComponent {
  constructor(props) {
    super(props);
    /**
     * Sets focus on the element
     */
    this.focus = () => {
      this.button.current && this.button.current.focus();
    };
    this.button = /*#__PURE__*/_react.default.createRef();
  }
  render() {
    var _this$props = this.props,
      {
        skin,
        underline,
        weight,
        size,
        children,
        className,
        dataHook,
        fluid,
        ellipsis,
        showTooltip,
        tooltipProps,
        ariaLabel,
        ariaLabelledBy,
        ariaHaspopup,
        ariaExpanded
      } = _this$props,
      rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
    return /*#__PURE__*/_react.default.createElement(_Ellipsis.default, (0, _extends2.default)({
      ellipsis: ellipsis,
      showTooltip: showTooltip
    }, tooltipProps, {
      render: _ref => {
        var {
          ref,
          ellipsisClasses
        } = _ref;
        return /*#__PURE__*/_react.default.createElement(_ButtonCore.default, (0, _extends2.default)({
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-haspopup": ariaHaspopup,
          "aria-expanded": ariaExpanded
        }, rest, (0, _generateDataAttr.generateDataAttr)(this.props, ['skin', 'size', 'weight', 'underline']), {
          ref: this.button,
          className: (0, _TextButtonSt.st)(_TextButtonSt.classes.root, {
            skin,
            underline,
            weight,
            size,
            fluid,
            ellipsis
          }, className),
          "data-hook": dataHook,
          contentClassName: ellipsisClasses(),
          contentRef: ref,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 118,
            columnNumber: 11
          }
        }), children);
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 113,
        columnNumber: 7
      }
    }));
  }
}
TextButton.displayName = 'TextButton';
TextButton.propTypes = {
  /** Renders component as any other component or a given HTML tag */
  as: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.string]),
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: _propTypes.default.string,
  /** Specifies the skin of a button */
  skin: _propTypes.default.oneOf(['standard', 'light', 'premium', 'dark', 'destructive']),
  /** Specifies whether to display and when to display an underline below button label */
  underline: _propTypes.default.oneOf(['none', 'onHover', 'always']),
  /** Controls the font weight of button label */
  weight: _propTypes.default.oneOf(['thin', 'normal']),
  /** Controls the size of a button */
  size: _propTypes.default.oneOf(['tiny', 'small', 'medium']),
  /** Defines a callback function which is called every time a button is clicked */
  onClick: _propTypes.default.func,
  /** Pass an icon or a component to display at the end of a label (e.g., svg, image, etc.) */
  suffixIcon: _propTypes.default.element,
  /** Pass an icon or a component to display at the front of a label (e.g., svg, image, etc.) */
  prefixIcon: _propTypes.default.element,
  /** Specifies whether user interactions are disabled */
  disabled: _propTypes.default.bool,
  /** Accepts any item as a child element. For all common cases pass a standard text string. */
  children: _propTypes.default.node,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: _propTypes.default.string,
  /** Stretches button to fill a 100% of its parent container width */
  fluid: _propTypes.default.bool,
  /** Specifies whether component handles text overflow with ellipsis. If enabled, label that exceed available space will be displayed inside of a tooltip when user hover over a button. */
  ellipsis: _propTypes.default.bool,
  /** Specifies whether the full button label is displayed in a tooltip when label overflows available space.
   *
   * Behaviour is enabled by default. Set property value to false to show ellipsis without a tooltip. */
  showTooltip: _propTypes.default.bool,
  /** Allows to pass all common tooltip props. Use it to customize a tooltip created from text ellipsis.
   * @linkTypeTo components-overlays--tooltip
   */
  tooltipProps: _propTypes.default.shape(_TooltipCommon.TooltipCommonProps),
  /** Defines a string value that labels the button element to screen reader users */
  ariaLabel: _propTypes.default.string,
  /** Identifies the element that labels the button element */
  ariaLabelledBy: _propTypes.default.string,
  /** Indicates to screen reader users whether an interactive popup element, such as menu or dialog, can be triggered by a button */
  ariaHaspopup: _propTypes.default.string,
  /** Indicates to screen reader users whether the collapsable content below is in the expanded or in the collapsed state */
  ariaExpanded: _propTypes.default.bool
};
TextButton.defaultProps = {
  skin: 'standard',
  underline: 'none',
  weight: 'thin',
  size: 'medium',
  disabled: false,
  fluid: false,
  tooltipProps: {}
};
var _default = exports.default = TextButton;
//# sourceMappingURL=TextButton.js.map